// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".d95a3f122ad29436a5e3cec0b94c0ddf694b3128.chunk.bundle.js";
};